import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.substr.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.number.to-precision.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.push.js";
import { mixin } from '@/mixins/register.js';
import Chart from 'chart.js';
import EmailItem from '@/components/emailItem/emailItem.vue';
import registerLoad from '@/components/registerLoad/index.vue';
import CurrencySelect from '@/components/currencySelect/index.vue';
import moment from 'moment';
import PremiumPriceOracle from '@/utils/PremiumPriceOracle';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Signin from '@/api/modules/signin';
import { AUTION } from '@/config/parameters.js';
import numberSkeleton from '@/components/numberSkeleton/index';
import floatOPS from '@/utils/floatOPS';
import Email from '@/api/modules/email';
import CallbackPupop from '@/components/common/callbackPupop.vue';
import gasNumber from '@/components/gasNumber/index';
export default {
  name: 'signin',
  components: {
    EmailItem: EmailItem,
    CallbackPupop: CallbackPupop,
    numberSkeleton: numberSkeleton,
    gasNumber: gasNumber,
    registerLoad: registerLoad,
    CurrencySelect: CurrencySelect
  },
  mixins: [mixin],
  props: {
    registerShow: {
      modelValue: Boolean
    },
    domain: {
      modelValue: Object
    },
    suffixClass: {
      modelValue: Object || Number
    },
    suffixType: {
      modelValue: Object || Number
    },
    registerDomainSuffix: {
      modelValue: String
    },
    isTld: {
      modelValue: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      selTime: 1,
      num: 1,
      testnet: process.env.VUE_APP_BASE_NET,
      couponList: '',
      selCouponPrice: 0,
      price: 0,
      originalPrice: 0,
      buyOutPrice: 0,
      introducePrice: 0,
      emailVisible: false,
      cost: 0,
      isFree: false,
      isDutchAuction: false,
      timer: null,
      targetDate: false,
      currentTargetDate: false,
      oracle: {},
      dutchAuctionTime: '',
      chartstartPremium: 0,
      currentPrice: '',
      commissionRate: 0,
      domainStatus: 0,
      registerPeriod: null,
      firstYearFreeFlag: false,
      loading: false,
      nowActive: 1,
      random_time: '',
      activePrice: 0,
      _chart: '',
      reminderData: {
        myDomainsReminder: false,
        reminder: false
      },
      copuonCollapse: '',
      premiumTime: '',
      registerPop: false,
      registerStatus: false,
      inputFlag: null,
      premiumDates: [],
      premiumLabels: [],
      registerChainIds: '',
      priceDiscount: 1,
      shareRatio: 0,
      registerPayMethod: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['chainid', 'account', 'signConnectCallBack1', 'accessToken'])), {}, {
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    },
    getDiscount: function getDiscount(priceDiscount) {
      return function (priceDiscount) {
        var num = floatOPS.s(1, priceDiscount, 3);
        return Number(num) * 100;
      };
    },
    getOriginalPrice: function getOriginalPrice(priceDiscount, originalPrice) {
      return function (priceDiscount, originalPrice) {
        var num = floatOPS.d(originalPrice, priceDiscount, 2);
        return num;
      };
    },
    nameLength: function nameLength(name) {
      return function (name) {
        if (name) {
          return name.length <= 19;
        } else {
          return false;
        }
      };
    },
    name: function name() {
      if (this.domain && this.domain.length > 19) {
        return this.domain.substr(0, 8) + '...' + this.domain.substr(this.domain.length - 8, 8);
      }
      return this.domain;
    }
  }),
  watch: {
    chainid: {
      handler: function handler(to, from) {
        if (to) {
          if (this.account && this.domain && !this.loading) {
            this.loading = true;
            this.init();
          }
        }
      },
      deep: true,
      immediate: false
    },
    account: {
      handler: function handler(to, from) {
        if (to && this.chainid && this.domain && !this.loading) {
          this.loading = true;
          this.init();
        }
      },
      deep: true,
      immediate: true
    },
    domain: {
      handler: function handler(to, from) {
        if (to) {
          if (this.account && this.chainid && !this.loading) {
            this.loading = true;
            this.setRemain();
            this.init();
          }
        }
      },
      deep: true,
      immediate: true
    },
    registerShow: {
      handler: function handler(to, from) {
        this.registerPop = this.registerShow;
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {
    this.$store.commit('setConnectPosition', 5);
    this.$store.commit('setIsNeedReload', false);
  },
  destroyed: function destroyed() {
    if (this.timer) {
      this.clearnCountDown();
    }
  },
  methods: {
    init: function init() {
      var _this = this;
      this.registerLoading = false;
      this.handleSelect(this.selTime);
      this.loading = true;
      this.getGasPrice(1, 1);
      this.gasTime = setInterval(function () {
        _this.getGasPrice(1, 1);
      }, 60000);
      this.getDomainStatus();
      this.getCoupons();
      this.signInviteInfo();
    },
    bugDisabled: function bugDisabled(val) {
      if (this.isUnSupport(this.registerChainIds).status) {
        return true;
      }
      if (val == 0 || val == 3) {
        return false;
      } else {
        return true;
      }
    },
    usdPriceAdd: function usdPriceAdd() {
      if (this.currencyId == this.chainid || !this.currencyId) {
        this.gasPrice = this.gasPriceInit;
        console.log(this.chainid, '======gasPrice=====', this.gasPrice);
      }
      if (this.gasPrice) {
        var num = "".concat(Number(this.gasPrice) + Number(this.price));
        if (isNaN(this.price)) {
          num = this.gasPrice;
        }
        var arrNum = num.split('.');
        var num1 = Number(arrNum[0]);
        var num2 = Number('0.' + arrNum[1]);
        if (num2 < 0.01) {
          num = Number(num1) + Number(num2.toPrecision(1));
        } else {
          num = (Number(num1) + Number(num2)).toFixed(2);
        }
        this.usdtPariceNum = num;
        if (this.currencyId == this.chainid || !this.currencyId) {
          this.getUseNum(num);
        } else {
          this.getUseNum(this.price);
        }
      }
    },
    focusBox: function focusBox(e) {
      if (this.inputFlag) {
        if (e != 1) {
          this.$refs.select.blur();
        } else {
          this.$refs['select-card1'].blur();
        }
      }
    },
    visibleChange: function visibleChange(val) {
      var _this2 = this;
      this.$setBodyStyle(val);
      setTimeout(function () {
        _this2.inputFlag = val;
      }, 100);
    },
    setRemain: function setRemain() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var json, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              json = {
                bizType: 3,
                bizValue: _this3.domain
              };
              _context.prev = 1;
              _context.next = 4;
              return Email.getEmailReminder(json);
            case 4:
              res = _context.sent;
              _this3.reminderData = res;
              _context.next = 10;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    getCouponPrice: function getCouponPrice() {
      var _this4 = this;
      var num = 0;
      this.priceList.forEach(function (item, i) {
        if (_this4.couponList == item.id) {
          num = item.value;
        }
      });
      return floatOPS.num(num);
    },
    getNumber: function getNumber(num) {
      var number = floatOPS.num(num);
      return number || 0.0;
    },
    calculate: function calculate(a, b, bit, fun) {
      var num = floatOPS[fun](a, b, bit);
      return num;
    },
    handleBtn: function handleBtn(e) {
      this.nowActive = e;
      if (e == 1) {
        // this.getInvitationCode();
      }
      // this.setPrice();
    },
    getFormatDate: function getFormatDate() {
      var date = moment(this.currentTargetDate).format('YYYY/MM/DD HH:MM');
      return date;
    },
    handleClosesBox: function handleClosesBox() {
      if (this.gasTime) {
        clearInterval(this.gasTime);
        this.gasTime = null;
      }
      this.$emit('handleClosesBox');
    },
    handleRegisterBox: function handleRegisterBox() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var couponList, arr, periodType, num, name, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              couponList = _this5.couponList ? [_this5.couponList] : [];
              if (_this5.selTime == 1) {
                periodType = 1;
                num = _this5.num;
              } else if (_this5.selTime == 2) {
                periodType = 5;
                num = 1;
              } else {
                periodType = 6;
                num = 1;
              }
              if (_this5.random_time) {
                periodType = 6;
                num = _this5.random_time;
              }
              if (_this5.isFree) {
                periodType = 0;
                num = 1;
              }
              if (_this5.isDutchAuction) {
                arr = {
                  name: _this5.domain,
                  periodType: periodType,
                  num: num
                };
              } else {
                arr = [{
                  name: _this5.domain,
                  periodType: periodType,
                  num: num
                }];
              }
              if (_this5.isTld) {
                name = _this5.domain;
                arr = {
                  name: _this5.$getTldDot(name),
                  periodType: periodType,
                  num: num
                };
              }
              if (_this5.inviteStatus != 2) {
                _this5.invitationCode = '';
              }
              _context2.next = 9;
              return _this5.handleRegister({
                arr: arr,
                activeName: couponList,
                is_card: false,
                is_object: _this5.isDutchAuction,
                is_renew: false,
                is_renew_popup: false,
                is_rigister: true,
                isTld: _this5.isTld,
                price: _this5.price
              });
            case 9:
              res = _context2.sent;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    setRegisterStatus: function setRegisterStatus() {
      this.registerStatus = true;
    },
    setCurrentPrice: function setCurrentPrice(e) {
      var num = 0;
      for (var i in this.premiumLabels) {
        if (Number(this.premiumLabels[i]) >= Number(e) && Number(this.premiumLabels[Number(i) + 1]) < Number(e)) {
          num = i;
        }
      }
      this.currentTargetDate = this.premiumDates[num];
    },
    currencySelectChange: function currencySelectChange(e, item) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this6.currencyId = e;
              _this6.currencySelect = item;
              _this6.gasPrice = 0;
              _this6.price = 0;
              _this6.usdtPariceNum = 0;
              _context3.next = 7;
              return _this6.getGasPrice(1, 1);
            case 7:
              res = _context3.sent;
              if (_this6.gasTime) {
                clearInterval(_this6.gasTime);
                _this6.gasTime = null;
              }
              _this6.gasTime = setInterval(function () {
                _this6.getGasPrice(1, 1);
              }, 60000);
              _this6.setPrice();
              // this.usdPriceAdd()
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getDomainStatus: function getDomainStatus() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var object, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              object = {
                names: [_this7.domain],
                periodTypes: [1],
                inviteCode: _this7.invitationCode
              };
              res = '';
              if (_this7.isTld) {
                _context4.next = 9;
                break;
              }
              _context4.next = 6;
              return Signin.getPriceInfo(object);
            case 6:
              res = _context4.sent;
              _context4.next = 13;
              break;
            case 9:
              object['strictCheck'] = true;
              _context4.next = 12;
              return Signin.getPriceInfoTld(object);
            case 12:
              res = _context4.sent;
            case 13:
              if (res.domains[_this7.domain].freeFlag) {
                _this7.isFree = true;
              }
              _this7.cost = Number(res.domains[_this7.domain].priceYear).toFixed(5);
              _this7.buyOutPrice = Number(res.domains[_this7.domain].buyoutPrice).toFixed(3);
              _this7.domainStatus = res.domains[_this7.domain].domainStatus;
              _this7.registerPeriod = res.domains[_this7.domain].registerPeriod;
              _this7.priceDiscount = parseFloat(Number(res.domains[_this7.domain].priceDiscount));
              _this7.shareRatio = parseFloat(Number(res.domains[_this7.domain].shareRatio));
              if (_this7.registerPeriod) {
                _this7.selTime = _this7.registerPeriod;
              }
              _this7.firstYearFreeFlag = res.domains[_this7.domain].firstYearFreeFlag;
              _this7.registerChainIds = res.domains[_this7.domain].registerChainIds;
              if (res.domains[_this7.domain].payMethod && res.domains[_this7.domain].payMethod.length > 0) {
                _this7.registerPayMethod = [res.domains[_this7.domain].payMethod];
              }
              if (res.domains[_this7.domain].domainStatus == 3) {
                _this7.isDutchAuction = true;
                _this7.dutchAuctionTime = moment(res.domains[_this7.domain].expiredAt * 1000).format('YYYY-MM-DD HH:00');
                _this7.$nextTick(function () {
                  setTimeout(function () {
                    _this7.setEcharts();
                  }, 1000);
                });
              }
              _this7.setPrice();
              _this7.loading = false;
              _context4.next = 32;
              break;
            case 29:
              _context4.prev = 29;
              _context4.t0 = _context4["catch"](0);
              _this7.loading = false;
              // this.$showTip(err,"error" );
            case 32:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 29]]);
      }))();
    },
    handleType: function handleType(e) {
      if (this.sessInvitationCode && e == 1) {
        this.invitationCode = this.sessInvitationCode;
        this.couponList = '';
        this.selCouponPrice = 0;
      }
      this.setPrice();
    },
    setEcharts: function setEcharts() {
      var _this8 = this;
      var labels = [];
      var dates = [];
      var data = [];
      var pointRadius = [];
      var supportLine = [];
      var oracle = new PremiumPriceOracle(this.dutchAuctionTime, 'exponential');
      this.oracle = oracle;
      var releasedDate = oracle.releasedDate,
        zeroPremiumDate = oracle.zeroPremiumDate,
        startingPremiumInUsd = oracle.startingPremiumInUsd;
      if (!this.targetDate) {
        this.targetDate = zeroPremiumDate;
        // this.currentPrice = oracle.getTargetAmountByDaysPast(
        //   oracle.getDaysPast(zeroPremiumDate)
        // );
      }

      var currentDate = moment(new Date().valueOf());
      var now = currentDate;
      var year = 1;
      var currentPremium = oracle.getTargetAmountByDaysPast(oracle.getDaysPast(currentDate));
      var ethUsdPrice = 1939.52136608;
      var daysRemaining = oracle.getDaysRemaining(now);
      var endDate = zeroPremiumDate;
      var startDate = releasedDate;
      this.targetDate = zeroPremiumDate;
      var ctx = document.getElementById('maychar').getContext('2d');
      var chartStartDate, maxTicksLimit;
      if (daysRemaining > 7) {
        chartStartDate = now;
        maxTicksLimit = daysRemaining;
      } else if (daysRemaining > 1) {
        chartStartDate = endDate.clone().subtract(7, 'day');
        maxTicksLimit = 7;
      } else {
        chartStartDate = endDate.clone().subtract(24, 'hour');
        maxTicksLimit = 24;
      }
      var chartstartPremium = oracle.getAmountByDateRange(startDate, chartStartDate);
      this.chartstartPremium = chartstartPremium;
      this.introducePrice = oracle.getAmountByDateRange(startDate, chartStartDate.clone());
      for (var i = chartStartDate.clone(); endDate.diff(i) > 0; i = i.add(1, 'hour')) {
        var premium = oracle.getAmountByDateRange(startDate, i).toFixed(2);
        var label = i.format('YYYY-MM-DD HH:00');
        dates.push(label);
        labels.push(premium);
        data.push(premium);
        this.premiumDates = dates;
        this.premiumLabels = labels;
        if (currentDate.format('YYYY-MM-DD HH:00') === label || startDate.format('YYYY-MM-DD HH:00') === label || this.targetDate.format('YYYY-MM-DD HH:00') === label || this.targetDate === label) {
          pointRadius.push(3);
        } else {
          pointRadius.push(null);
        }
        if (this.targetDate === label) {
          supportLine.push(2000);
        } else {
          supportLine.push(null);
        }
      }
      var that = this;
      this.setPrice();
      this.$nextTick(function () {
        _this8._chart = new Chart(ctx, {
          type: 'line',
          data: {
            labels: dates,
            //Bring in data
            datasets: [{
              label: 'Passed',
              borderWidth: 3,
              data: data,
              borderColor: '#26A062',
              backgroundColor: '#26A062',
              pointRadius: pointRadius,
              fill: false
            }, {
              label: 'Estimate',
              borderWidth: 2,
              data: labels,
              borderColor: '#D8D8D8',
              pointBackgroundColor: '#26A062',
              pointBorderColor: '#26A062',
              fill: false,
              pointRadius: pointRadius
            }]
          },
          options: {
            events: ['click'],
            animation: {
              duration: 0
            },
            tooltips: {
              enabled: true,
              mode: 'nearest',
              intersect: false,
              titleAlign: 'center',
              multiKeyBackground: '#2C46A6',
              callbacks: {
                label: function label(tooltipItem, data) {
                  that.handleTooltip(tooltipItem);
                  var label = "Premium: $".concat(tooltipItem.yLabel.toFixed(2));
                  if (tooltipItem.datasetIndex === 1) {
                    return label;
                  }
                }
              }
            },
            responsive: true,
            aspectRatio: 5,
            legend: {
              display: false
            },
            scales: {
              xAxes: [{
                afterFit: function afterFit(scale) {
                  scale.height = 0;
                },
                ticks: {
                  maxTicksLimit: maxTicksLimit,
                  callback: function callback() {
                    return '';
                  }
                },
                gridLines: {
                  zeroLineColor: '#e9eef6',
                  zeroLineWidth: 3,
                  color: 'white',
                  lineWidth: 3,
                  offsetGridLines: false,
                  drawBorder: false
                }
              }],
              yAxes: [{
                ticks: {
                  display: false,
                  max: chartstartPremium * 1.5
                },
                gridLines: {
                  display: false,
                  drawBorder: false
                }
              }]
            },
            layout: {
              padding: {
                bottom: 5,
                top: 5
              }
            }
          }
        });
        _this8._chart.update();
      });
    },
    handleTooltip: function handleTooltip(tooltipItem) {
      var delimitedParsedValue = tooltipItem.yLabel;
      this.targetDate = this.oracle.getTargetDateByAmount(delimitedParsedValue);
      this.currentTargetDate = this.oracle.getTargetDateByAmount(delimitedParsedValue);
      this.currentPrice = delimitedParsedValue.toFixed(2);
    },
    setTimeDomain: function setTimeDomain() {},
    handleManager: function handleManager() {
      this.$router.push({
        path: '/manager',
        query: {
          name: this.domain
        }
      });
    },
    getTitle: function getTitle() {
      if (this.suffixClass == 2) {
        return this.domain + this.$t("query.free_suffix");
      } else if (this.suffixType == 3) {
        return this.domain + this.$t("query.new_suffix");
      } else if (this.suffixType == 3) {
        return this.domain + this.$t("query.hot_suffix");
      }
    },
    handleClose: function handleClose() {
      this.setRemain();
      this.emailVisible = false;
    },
    handleVisible: function handleVisible() {
      if (this.reminderData.reminder) return;
      this.premiumTime = moment(this.targetDate).unix();
      if (!this.premiumTime) {
        return;
      }
      if (!this.currentPrice) {
        return;
      }
      this.emailVisible = true;
    },
    handleSelect: function handleSelect(e) {
      this.selTime = e;
      if (e == 1) {
        this.setPrice();
      } else {
        this.setPrice(1);
      }
    },
    handleListSel: function handleListSel(e) {
      var _this9 = this;
      this.priceList.forEach(function (item, i) {
        if (item.id == _this9.couponList) {
          _this9.selCouponPrice = Number(item.value);
        }
      });
      if (!this.couponList) {
        this.selCouponPrice = 0;
      }
      this.invitationCode = '';
      this.setPrice();
    },
    handleChangeYear: function handleChangeYear(value) {
      this.setPrice();
    },
    maxSetPrice: function maxSetPrice() {},
    setPrice: function setPrice(e) {
      this.usdPrice = '';
      if (this.selTime == 2) {
        this.originalPrice = this.buyOutPrice;
      } else {
        this.originalPrice = floatOPS.m(this.cost, this.num, 2);
        if (Number(this.firstYearFreeFlag) > 0 && this.selTime == 1 && !this.isFree) {
          this.originalPrice = Number(this.originalPrice) - Number(this.cost);
        }
      }
      if (this.nowActive == 1) {
        if (this.inviteStatus == 2) {
          this.price = floatOPS.m(this.originalPrice, this.inviteeDiscount, 2);
        } else {
          this.price = this.originalPrice;
        }
      } else {
        if (this.selCouponPrice == 0) {
          this.price = this.originalPrice;
        } else {
          if (this.selCouponPrice <= this.originalPrice) {
            this.price = floatOPS.s(this.originalPrice, this.selCouponPrice, 2);
          } else {
            this.price = 0;
          }
        }
      }
      if (this.isDutchAuction) {
        this.price = Number(this.introducePrice) + Number(this.price);
      }
      this.usdPriceAdd();
    },
    isUnSupport: function isUnSupport(item) {
      return this.$isUnSupport(item);
    }
  }
};